package shared.models

data class ProductCard(
    val name: String,
    val tagline: String,
    val url: String,
    val description: String
)
